import { useQuery } from '@tanstack/react-query';
import {
  WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS,
  WEBSITE_ANALYTICS_TOP_PAGES_LIMIT,
} from '../constants';
import { fetchWebsiteAnalyticsTopPages } from '../services/websiteAnalytics.api';
import type { WebsiteAnalyticsDays } from '../types';

export function useWebsiteAnalyticsTopPages(
  days: WebsiteAnalyticsDays,
  productSlug: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: [
      'website-analytics',
      'top-pages',
      days,
      productSlug ?? 'all',
      WEBSITE_ANALYTICS_TOP_PAGES_LIMIT,
    ],
    queryFn: () => fetchWebsiteAnalyticsTopPages(days, productSlug),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
